import "./interface.scss";

import PropTypes from "prop-types";
import React from "react";

import Icon from "./Icon";
import Tooltip from "./Tooltip";

const HelpIcon = props => {
  return (
    <Tooltip text={props.tooltip} triggerOnClick={true} offset="0, 10" placement="bottom-start">
      <div className="helpIcon">
        <Icon icon="helpIcon" />
      </div>
    </Tooltip>
  );
};

HelpIcon.defaultProps = {};

HelpIcon.propTypes = {
  tooltip: PropTypes.string.isRequired
};

export default HelpIcon;
